import mapStyle from './map-style';
/* eslint no-console: ["error", { allow: ["error"] }] */


const initMap = () => {
    const maps = Array.from(document.querySelectorAll('#map'));
    maps.forEach((item) => {
        const address = item.dataset.address;
        const geocoder = new google.maps.Geocoder();

        geocoder.geocode({ address }, (results, status) => {
            if (status === 'OK') {
                const lat = results[0].geometry.location.lat();
                const lng = results[0].geometry.location.lng();
                const map = new google.maps.Map(item, {
                    center: { lat, lng },
                    zoom: 16,
                    disableDefaultUI: true,
                    styles: mapStyle,
                });
                new google.maps.Marker({
                    map,
                    position: results[0].geometry.location,
                    icon: '/dist/images/pin-orange.png',
                });
            } else {
                console.error(`Geocode was not successful for the following reason: ${status}`);
            }
        });
    });
};

export default(() => {
    window.initMap = initMap;
})();
